import { useEffect } from "react";
import decodeToken from "./decodeToken";

export const SPONSOR_RESUME_KEY = "shaagird_sponsor_resume";

/** Safe internal path for post-login redirect (avoid open redirects). */
export function sanitizeReturnPath(from) {
  if (
    typeof from !== "string" ||
    !from.startsWith("/") ||
    from.startsWith("//")
  ) {
    return "/";
  }
  return from;
}

export function writeSponsorResume(payload) {
  sessionStorage.setItem(
    SPONSOR_RESUME_KEY,
    JSON.stringify({
      kidId: payload.kidId,
      months: payload.months,
      isSubscription: payload.isSubscription,
      returnPath: payload.returnPath,
    }),
  );
}

export function readSponsorResume() {
  try {
    const raw = sessionStorage.getItem(SPONSOR_RESUME_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export function clearSponsorResume() {
  sessionStorage.removeItem(SPONSOR_RESUME_KEY);
}

/**
 * After "Become a Mentor" → login, reopen the sponsor modal on this page when resume matches the URL.
 */
export function useSponsorResumeReopen(setSelectedKidId, setShowSponsorModal) {
  useEffect(() => {
    const resume = readSponsorResume();
    if (!resume?.kidId || !resume?.returnPath) return;
    const { user_id } = decodeToken();
    if (!user_id) return;
    const here = window.location.pathname + window.location.search;
    if (resume.returnPath !== here) return;
    setSelectedKidId(resume.kidId);
    setShowSponsorModal(true);
  }, [setSelectedKidId, setShowSponsorModal]);
}
